import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import BaseNotification from '../Base'

const trackGoToCreateCards = () => {
  track(trackingEvents.expenses.gotToCreateCard, {
    source: 'notification_cta',
  })
}

const CardsNotification = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return (
    <BaseNotification
      type="info"
      compact
      action={
        <Button
          type="secondary"
          onClick={() => {
            navigate(navigation.expenses.new_card.fullPath())
            trackGoToCreateCards()
          }}
        >
          {i18n.t('expenses_v2.alerts.cards.create_cards.cta')}
        </Button>
      }
      description={i18n.t('expenses_v2.alerts.cards.create_cards.description')}
    />
  )
}

export default CardsNotification
